import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateJob } from '../api';
import type { UpdateJobInput } from '@maker-toolchest/shared';

export function useUpdateJob(jobId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateJobInput) => updateJob(jobId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['job', jobId] });
    },
  });
}
